import { SubCustomersRequestsActionsNames } from './subCustomersRequests.actions';
import { SubCustomersRequestsState, SubCustomersRequestsAction } from './type';
import { ISubCustomersRequest } from '../../../models/subCustomersRequest';
import { IApiError } from '../../../models/api';

const initialState: SubCustomersRequestsState = {
  isLoading: false,
  error: null,
  subCustomersRequests: [],
  selectedSubCustomersRequest: null,
};

const subCustomersRequestsReducer = (
  state: SubCustomersRequestsState = initialState,
  action: SubCustomersRequestsAction
): SubCustomersRequestsState => {
  switch (action.type) {
    case SubCustomersRequestsActionsNames.GET_SUB_CUSTOMERS_REQUESTS.START:
      return {
        ...state,
        error: null,
        isLoading: true,
        subCustomersRequests: [],
      };
    case SubCustomersRequestsActionsNames.GET_SUB_CUSTOMERS_REQUESTS.FULFILLED:
      return {
        ...state,
        isLoading: false,
        subCustomersRequests: (action.payload ?? []) as ISubCustomersRequest[],
      };
    case SubCustomersRequestsActionsNames.GET_SUB_CUSTOMERS_REQUEST_BY_ID.START:
      return { ...state, isLoading: true, error: null, selectedSubCustomersRequest: null };
    case SubCustomersRequestsActionsNames.GET_SUB_CUSTOMERS_REQUEST_BY_ID.FULFILLED:
      return {
        ...state,
        isLoading: false,
        selectedSubCustomersRequest: action.payload as ISubCustomersRequest ?? null,
      };
    case SubCustomersRequestsActionsNames.GET_SUB_CUSTOMERS_REQUEST_BY_ID.REJECTED:
    case SubCustomersRequestsActionsNames.GET_SUB_CUSTOMERS_REQUESTS.REJECTED:
    case SubCustomersRequestsActionsNames.UPDATE_SUB_CUSTOMERS_REQUEST.REJECTED:
      return {
        ...state,
        isLoading: false,
        error: action.payload as IApiError[] ?? null,
      };
    case SubCustomersRequestsActionsNames.UPDATE_SUB_CUSTOMERS_REQUEST.START:
      return { ...state, isLoading: true, error: null };
    case SubCustomersRequestsActionsNames.UPDATE_SUB_CUSTOMERS_REQUEST.FULFILLED:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

export default subCustomersRequestsReducer;
